import { axiosAuth } from '../../Axios';
import * as actionTypes from './actionTypes';

const authStart = () => ({ type: actionTypes.AUTH_START });
const authSuccess = (token, role) => ({ type: actionTypes.AUTH_SUCCESS, token, role });
const authFail = () => ({ type: actionTypes.AUTH_FAIL });
const authLogout = () => ({ type: actionTypes.AUTH_LOGOUT });

export const login = values => {
  return dispatch => {
    dispatch(authStart());

    return axiosAuth
      .post('/admin_tokens', values)
      .then(res => {
        const { token, role } = res.data;
        dispatch(authSuccess(token, role));
        window.localStorage.setItem('token', token);
        window.localStorage.setItem('role', role);
      })
      .catch(err => {
        console.log('%c <#authentication> Error: ' + err, 'background: red; color: white');
        dispatch(authFail());
        return Promise.reject(err);
      });
  };
};

export const checkLogin = () => dispatch => {
  console.log('%c Checking user authentication! ', 'background: blue; color: white');
  const token = window.localStorage.getItem('token');
  const role = window.localStorage.getItem('role');
  if (!token || !role) {
    console.log('%c No user found.. ', 'background: blue; color: white');
    dispatch(authLogout());
    console.log('%c Proceeded to call <AUTH_LOGOUT> ', 'background: blue; color: white');
  } else {
    console.log('%c User found.. ', 'background: blue; color: white');
    console.log('%c Proceeding to automatic log-in ', 'background: blue; color: white');
    dispatch(authSuccess(token, role));
  }
};

export const logout = () => {
  return dispatch => {
    localStorage.clear();
    dispatch(authLogout());
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js